import axios from 'axios'
import { toast } from 'react-toastify'

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  PROFILE_INFO_REQUEST,
  PROFILE_INFO_SUCCESS,
  PROFILE_INFO_FAILURE
} from '../constants'
import { ProfileInfo } from 'components/common/types'
import { TypedThunk } from 'reducers'

export const login =
  (email, password, redirect, errorModalHandler): TypedThunk<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LOGIN_REQUEST })

      const { data } = await axios.post('/login', { email, password })

      dispatch({
        type: LOGIN_SUCCESS,
        payload: data
      })

      redirect()
    } catch (error) {
      dispatch({
        type: LOGIN_FAILURE,
        payload: error?.response?.data?.Message || 'The request is invalid.'
      })

      errorModalHandler()
    }
  }

export const signUp =
  (email, password, confirmPassword, redirect, errorModalHandler) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: SIGNUP_REQUEST })

      const { data } = await axios.post('/signup', {
        Email: email,
        Password: password,
        ConfirmPassword: confirmPassword
      })

      dispatch({
        type: SIGNUP_SUCCESS,
        payload: data
      })

      redirect()
    } catch (error) {
      dispatch({
        type: SIGNUP_FAILURE,
        payload: error?.response?.data?.Message || 'The request is invalid.'
      })

      errorModalHandler()
    }
  }

export const forgotPassword =
  (email, successCallback) => async (dispatch, getState) => {
    try {
      dispatch({ type: FORGOT_PASSWORD_REQUEST })

      const data = await axios.post('/forgot_password', {
        email
      })

      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: data
      })

      toast.info('We sent an email to change your password.', {
        autoClose: 3000,
        onClose: successCallback
      })
    } catch (error) {
      const errorMessage =
        error?.response?.data?.Message || 'The request is invalid.'

      dispatch({
        type: FORGOT_PASSWORD_FAILURE,
        payload: errorMessage
      })

      toast.error(errorMessage, { autoClose: 3000 })
    }
  }

export const getProfileInfo =
  (): TypedThunk<Promise<void>> => async (dispatch, getState) => {
    try {
      dispatch({ type: PROFILE_INFO_REQUEST })

      const { data } = await axios.get<ProfileInfo>('/user/profile')

      dispatch({
        type: PROFILE_INFO_SUCCESS,
        payload: {
          Email: data.Email,
          EmailConfirmed: data.EmailConfirmed,
          FirstName: data.FirstName ?? '',
          Id: data.Id,
          IsPhoneNumberDefault: data.IsPhoneNumberDefault,
          LastName: data.LastName ?? '',
          PhoneNumber: data.PhoneNumber ?? null,
          PhoneNumber2: data.PhoneNumber2 ?? null,
          PhoneNumber2Confirmed: data.PhoneNumber2Confirmed,
          PhoneNumberConfirmed: data.PhoneNumberConfirmed,
          UserName: data.UserName,
          customerAddresses: data.customerAddresses
        }
      })
    } catch (error) {
      dispatch({
        type: PROFILE_INFO_FAILURE,
        payload: error?.response?.data?.Message || 'The request is invalid.'
      })
    }
  }
